import { GridService } from '../shared/grid/grid.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MasterAgent } from '../models/masterAgent.model';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { Lookup } from '../models/lookup.model';

@Injectable({
  providedIn: 'root'
})
export class MasterAgentService extends GridService<MasterAgent> {

    private cache$: Observable<Lookup[]> | null = null;

    constructor(http: HttpClient) {
        super('MasterAgent', http);
    }

    getAll(filterBy: string = ''): Observable<Lookup[]> {
        if (filterBy) {
            const params = new HttpParams().set('filterBy', filterBy);
            return this.http.get<Lookup[]>(this.getApiUrl(`${this.controllerName}/GetAll`), { params });
        }
        if (!this.cache$) {
            this.cache$ = this.http.get<Lookup[]>(this.getApiUrl(`${this.controllerName}/GetAll`)).pipe(
                shareReplay({ bufferSize: 1, refCount: true })
            );
        }
        return this.cache$;
    }

    clearCache(): void {
        this.cache$ = null;
    }

    override create(payload: MasterAgent) {
        return super.create(payload).pipe(tap(() => this.clearCache()));
    }

    override update(payload: MasterAgent) {
        return super.update(payload).pipe(tap(() => this.clearCache()));
    }

    override delete(id: string) {
        return super.delete(id).pipe(tap(() => this.clearCache()));
    }

    override patch(id: string, payload: Partial<MasterAgent>) {
        return super.patch(id, payload).pipe(tap(() => this.clearCache()));
    }

    override createRange(payload: MasterAgent[]) {
        return super.createRange(payload).pipe(tap(() => this.clearCache()));
    }
}
